// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__R1A6a","title":"footer_title__laI6c","description":"footer_description__HiY4n","footerlink":"footer_footerlink__6cAJ6"};